import React, { Component } from "react";
import getLiveByGroup from "../../services/livegrouptrack";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import { Row, Col, Spinner, Container } from "reactstrap";

class GroupTracking extends Component {
  state = {
    listOfVehicle: [],
    isLoading: true,
  };

  componentDidMount() {
    this.callDashboardData();
  }

  async callDashboardData() {
    const listOfVehicle = await getLiveByGroup();
    this.setState({ listOfVehicle, isLoading: false });
  }
  render() {
    return (
      <Container className="pt-8 header bg-gradient-info">
        {this.state.isLoading ? (
          <Row className="p-9">
            <Col style={{ textAlign: "center" }}>
              <Spinner color="success" />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <Map
                style={{ height: "500px" }}
                google={this.props.google}
                zoom={14}
                containerStyle={{ height: "600px", width: "90%" }}
                initialCenter={{
                  lat: this.state.listOfVehicle[0].lat,
                  lng: this.state.listOfVehicle[0].lnt,
                }}
                center={{
                  lat: this.state.listOfVehicle[0].lat,
                  lng: this.state.listOfVehicle[0].lnt,
                }}
              >
                {this.state.listOfVehicle.map((marker) => (
                  <Marker
                    position={{
                      lat: parseFloat(parseFloat(marker.lat).toFixed(3)),
                      lng: parseFloat(parseFloat(marker.lnt).toFixed(3)),
                    }}
                  />
                ))}
              </Map>
            </Col>
          </Row>
        )}
        <div className="pb-8"></div>
        <div className="pb-8"></div>
        <div className="pb-8"></div>
        <div className="pb-8"></div>
      </Container>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyArpzS5JA0kvLuWIWBnfTl4du8eIhJIoU4",
})(GroupTracking);
